import { authService }   from "@/services/auth.service";
import jwt_decode        from "jwt-decode";

//state
const state = () => ({
	accessToken: '',
	username:    '',
	name:        '',
	isSignedIn:  false,
	fresh: true
})

//getters
const getters = {
	accessToken:function(state) {
		return state.accessToken;
	}
}

// actions
const actions = {
	forceFreshStateToFalse:function({commit}) {
		commit('setFresh', false);
	},

	signIn:function( ) {
		authService.signIn();
	},

	signOut: function({ state, commit }) {
		let username = state.username;
		authService.signOut( username );
		setTimeout(()=>commit('setLoggedOut'), 1500 )
	},

	getAccessToken:async function({state, commit}) {
		let getNewToken = false;

		try {
			let decodedCurrentAccessToken = jwt_decode(state.accessToken);
			if (Date.now() >= (decodedCurrentAccessToken.exp * 1000)) {
				getNewToken = true;
			}
		}
		catch {
			getNewToken = true;
		}

		if(getNewToken) {
			let accessToken = await authService.getAccessToken( state.username );
			commit('setAccessToken', accessToken);
			return accessToken;
		}
		else {
			return state.accessToken;
		}
	},

	/**
	 *
	 * @param commit
	 * @param dispatch
	 * @returns {Promise<void>}
	 * @throws {authError}
	 */
	initialize:async function({commit, dispatch}) {
		await commit('setModuleStateFromLocalStorage');
		await authService.pageLoad().then(function(user){
			commit('setUser', user);
			//if the user is signed in and no access token was provided in the response (a page reload, verify the token we have saved is still valid or refresh it if not)
			if(user.isSignedIn && !user.accessToken) {
				dispatch('getAccessToken');
			}
			commit('setFresh', true);
			//otherwise, the router sends the user to /signin and that vue handles triggering an actual log in.
		});
	}
}

// actions
const mutations = {

	setAccessToken:function(state,accessToken) {
		state.accessToken = accessToken;
	},

	setUser: function ( state, user ) {
		state.isSignedIn = user.isSignedIn;
		state.accessToken = user.accessToken || state.accessToken;
		state.username = user.username;
		state.name = user.name;
	},


	setFresh: function ( state, fresh ) {
		state.fresh = fresh;
	},

	setLoggedOut: function(state) {
		state.isSignedIn = false;
		state.accessToken = '';
		state.username = '';
		state.name = '';
	},

	setModuleStateFromLocalStorage:function(state) {
		if ( localStorage.getItem( 'store.microsoftAuth' ) ) {
			// Replace the state object with the stored item
			let data = JSON.parse( localStorage.getItem( 'store.microsoftAuth' ) );
			if(data!==null) {
				data.fresh = false;
				Object.assign(state, data)
			}
		}
	}

}

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations
}